module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "access"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      ACCES AU CABINET\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-4 row mb-4 text-left"
  }, [_c('div', {
    staticClass: "col-12 section-title"
  }, [_c('h5', {
    staticClass: "pb-1"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v("\n            Clinique Sainte Genevieve\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            29 Rue Sarrette, 75014 Paris\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 section-title"
  }, [_c('h5', {
    staticClass: "pb-1"
  }, [_vm._v("Prise de rendez-vous")]), _vm._v(" "), _c('div', [_vm._v("\n          Prendre rendez-vous sur Doctolib : "), _c('a', {
    attrs: {
      "href": "https://www.doctolib.fr/dentiste/paris/ryan-saad"
    }
  }, [_vm._v("Cliquez ici !")])]), _vm._v(" "), _c('div', [_vm._v("\n            Prendre rendez-vous par téléphone : "), _c('b', {
    attrs: {
      "href": "tel:0156535858"
    }
  }, [_vm._v("01 56 53 58 58")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 section-title"
  }, [_c('h5', {
    staticClass: "pb-1"
  }, [_vm._v("Moyens de transport")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Tramway")]), _vm._v(" - Porte d'Orléans (T3a)\n        ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Métro")]), _vm._v(" - Alésia/Porte d'Orléans (ligne 4)\n        ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("RER")]), _vm._v(" - Denfert-Rochereau (ligne B)\n        ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Bus")]), _vm._v(" - Rue d'Alésia (ligne 62)\n        ")]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Bus")]), _vm._v(" - Avenue du Général Leclerc (ligne 28, 38, 68)\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 section-title"
  }, [_c('h5', {
    staticClass: "pb-1"
  }, [_vm._v("Parking public")]), _vm._v(" "), _c('div', [_vm._v("\n          19 Rue Saint-Yves, 75014 Paris\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 section-title"
  }, [_c('h5', {
    staticClass: "pb-1"
  }, [_vm._v("Informations pratiques")]), _vm._v(" "), _c('div', [_vm._v("\n          Cabinet au rez-de-chaussée\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            Accès aux personnes à mobilité réduite (PMR)\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-8"
  }, [_c('figure', [_c('div', {
    staticClass: "mapouter"
  }, [_c('div', {
    staticClass: "gmap_canvas"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "500",
      "id": "gmap_canvas",
      "src": "https://maps.google.com/maps?ll=48.8302091,2.329350499999999&q=Dr Ryan SAAD - Chirurgie Orale & Implantologie&t=&z=15&ie=UTF8&iwloc=&output=embed",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0"
    }
  })])]), _vm._v(" "), _c('figcaption', {})])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a83f80c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a83f80c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/access/access.component.html
// module id = 267
// module chunks = 1